<template>
    <div class="depot">
        <headerNotice routerName="满赠"></headerNotice>
        <!-- 搜索框 -->
        <div class="seach-box">
            <h2 class="title">
                <i></i>
                <span>筛选查询</span>
            </h2>
            <div class="input-wrapper">
                <el-row :gutter="24">
                    <!-- 輸入框 -->
                    <el-col :span="6" :offset="0">
                        <div>
                            <span>促销名称：</span>
                            <el-input
                                class="el-search"
                                v-model="promotionName"
                                placeholder="仓库名称/仓库编号"
                            ></el-input>
                        </div>
                    </el-col>
                    <!-- 状态选择 -->
                    <el-col :span="7" :offset="0">
                        <div class="status">
                            <span>状态：</span>
                            <el-select v-model="stateValue" @change="selectGet" placeholder="全部">
                                <el-option
                                    v-for="item in options"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value"
                                ></el-option>
                            </el-select>
                        </div>
                    </el-col>
                    <!-- 日期选择 -->
                    <el-col :span="9" :offset="0">
                        <div class="status">
                            <el-date-picker
                                v-model="dateValue"
                                type="datetimerange"
                                format="yyyy-MM-dd HH:mm:ss"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                align="right"
                                unlink-panels
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                :picker-options="pickerOptions2"
                            ></el-date-picker>
                        </div>
                    </el-col>
                    <!-- 查询按钮 -->
                    <el-col :span="1" :offset="0">
                        <div class="status">
                            <el-button type="primary" @click="searchConfirm">查询</el-button>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </div>
        <!-- 促销列表 -->
        <div class="depot-list">
            <div class="head">
                <h2 class="title">
                    <i></i>
                    <span>促销列表</span>
                </h2>
                <div class="control">
                    <el-button class="tip-box" @click="addFullFift">添加</el-button>
                </div>
            </div>
            <!-- 添加Dialog框 -->
            <div class="add-box" v-loading="loading">
                <el-dialog
                    width="600px"
                    title="添加满赠:"
                    :visible.sync="showAddBox"
                    @close="closeDialog"
                >
                    <el-form class="from-el" :model="formData">
                        <el-form-item :rules="{required: true}" label="满赠促销名称:" label-width="138px">
                            <el-input
                                placeholder="不能为空，1~20个字符"
                                class="input-el"
                                v-model="formData.activeName"
                                autocomplete="off"
                                maxlength="20"
                            ></el-input>
                        </el-form-item>
                        <el-form-item :rules="{required: true}" label="开始时间:" label-width="138px">
                            <el-date-picker
                                :readonly="readonly"
                                v-model="formData.startTime"
                                type="datetime"
                                format="yyyy-MM-dd HH:mm:ss"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                placeholder="选择开始时间"
                                default-time="12:00:00"
                            ></el-date-picker>
                        </el-form-item>
                        <el-form-item :rules="{required: true}" label="结束时间:" label-width="138px">
                            <el-date-picker
                                :readonly="readonly"
                                v-model="formData.endTime"
                                type="datetime"
                                format="yyyy-MM-dd HH:mm:ss"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                placeholder="选择结束时间"
                                default-time="12:00:00"
                            ></el-date-picker>
                        </el-form-item>
                        <el-form-item
                            :rules="{required: true}"
                            label="商品订购数量满足:"
                            label-width="138px"
                        >
                            <el-input
                                :readonly="readonly"
                                placeholder="请输入数量"
                                class="input-el"
                                v-model="formData.reach"
                                autocomplete="off"
                                type="number"
                            >
                                <template slot="append">件</template>
                            </el-input>
                        </el-form-item>
                        <el-form-item :rules="{required: true}" label="获取赠品:" label-width="138px">
                            <el-input
                                :readonly="readonly"
                                placeholder="请输入数量"
                                class="input-el"
                                v-model="formData.freebieNum"
                                autocomplete="off"
                                type="number"
                            >
                                <template slot="append">个</template>
                            </el-input>
                        </el-form-item>
                        <el-form-item
                            :rules="{required: true}"
                            label="赠品选择:"
                            label-width="140px"
                        >
                            <el-button style="margin-right:35px;" :readonly="readonly" @click="openShowGiveaway()">选择赠品</el-button>
                            已选择
                            {{giveawayNum}}件赠品
                        </el-form-item>
                        <el-form-item :rules="{required: true}" label="适合的客户:" label-width="140px">
                            <el-radio-group v-model="formData.customerScope">
                                <el-radio :label="1">全部客户</el-radio>
                                <el-radio :label="2">新客户</el-radio>
                                <el-radio :label="3">老客户</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item :rules="{required: true}" label="活动范围:" label-width="140px">
                            <el-radio-group v-model="formData.cityScope">
                                <el-radio :label="1">全部地区</el-radio>
                                <!-- <el-radio :label="2">指定地区</el-radio> -->
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item
                            :rules="{required: true}"
                            label="地区选择:"
                            label-width="140px"
                            v-if="formData.cityScope == 2"
                        >
                            <el-button style="margin-right:35px;" @click="showArea = true">选择地区</el-button>
                            已选择
                            {{areaNumber}}个地区
                        </el-form-item>
                        <el-form-item :rules="{required: true}" label="活动商品:" label-width="140px">
                            <el-radio-group v-model="formData.itemPropScope">
                                <el-radio :label="1">全场通用</el-radio>
                                <el-radio :label="2">指定商品</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item
                            :rules="{required: true}"
                            label="商品制定:"
                            label-width="140px"
                            v-if="formData.itemPropScope == 2"
                        >
                            <el-button style="margin-right:35px;" @click="openShowGoods()">选择商品</el-button>
                            已选择
                            {{goodsNum}}个商品
                        </el-form-item>
                        <el-form-item label="促销活动描述:" label-width="140px">
                            <el-input
                                type="textarea"
                                :autosize="{ minRows: 2, maxRows: 4}"
                                placeholder="请输入内容"
                                v-model="formData.content"
                            ></el-input>
                        </el-form-item>
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="showAddBox = false">取 消</el-button>
                        <el-button type="primary" @click="addFullReduction(state)">确 定</el-button>
                    </div>
                </el-dialog>
            </div>
            <!-- 地区选择Dialog框 -->
            <div class="add-box" v-loading="loading">
                <el-dialog width="500px" title="选择地区:" :visible.sync="showArea">
                    <div v-loading="dialogLoading">
                        <el-tree
                            :data="reginData"
                            show-checkbox
                            node-key="code"
                            :default-checked-keys="defaultKeys"
                            accordion
                            :props="defaultProps"
                            ref="reginTree"
                        ></el-tree>
                    </div>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="showArea = false">取 消</el-button>
                        <el-button type="primary" @click="getArea">确 定</el-button>
                    </div>
                </el-dialog>
            </div>
            <!-- 商品选择Dialog框 -->
            <div class="add-box">
                <el-dialog width="700px" title="选择商品:" :visible.sync="showGoods">
                    <el-form class="from-el" :model="goodsForm">
                        <!-- 搜索Dialog框 -->
                        <el-col :span="12" :offset="0">
                            <el-input placeholder="请输入名称/编号/规格/规格编号" v-model="goodsForm.keyword">
                                <el-button slot="append" icon="el-icon-search" @click="searchGoods"></el-button>
                            </el-input>
                        </el-col>
                        <el-table
                            ref="multipleTable"
                            :data="goodsList"
                            style="width: 100%"
                            :default-sort="{prop: 'date', order: 'descending'}"
                            @selection-change="handleCustomerSelectionChange"
                            v-loading="dialogLoading"
                        >
                            <el-table-column type="selection" width="55"></el-table-column>
                            <el-table-column prop="title" label="商品名称" width="300"></el-table-column>
                            <el-table-column prop="itemCode" label="商品编码" width="120"></el-table-column>
                            <el-table-column prop="price" label="价格" width="120"></el-table-column>
                        </el-table>
                        <!--分页-->
                        <el-pagination
                            class="pagination"
                            @size-change="handleCustomeSizeChange"
                            @current-change="handleCustomerCurrentChange"
                            :page-sizes="[25, 50, 75, 100]"
                            layout="total, sizes, next"
                            :background="true"
                            next-text="点击加载更多⇣⇣"
                            :total="goodsTotalCount"
                        ></el-pagination>
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="showGoods = false">取 消</el-button>
                        <el-button type="primary" @click="getGoodsNum">确 定</el-button>
                    </div>
                </el-dialog>
            </div>
            <!-- 赠品选择Dialog框 -->
            <div class="add-box">
                <el-dialog width="700px" title="选择赠品:" :visible.sync="showGiveaway">
                    <el-form class="from-el" :model="giveawayForm">
                        <!-- 搜索Dialog框 -->
                        <el-col :span="12" :offset="0">
                            <el-input placeholder="赠品名称/赠品编码" v-model="giveawayForm.keyword">
                                <el-button slot="append" icon="el-icon-search" @click="searchGiveaway"></el-button>
                            </el-input>
                        </el-col>
                        <el-table
                            ref="multipleTablezp"
                            :data="giveawayList"
                            style="width: 100%"
                            :default-sort="{prop: 'date', order: 'descending'}"
                            @selection-change="handleGiftSelectionChange"
                            v-loading="dialogLoading"
                        >
                            <el-table-column type="selection" width="55"></el-table-column>
                            <el-table-column prop="title" label="赠品名称" width="300"></el-table-column>
                            <el-table-column prop="propName" label="规格名称" width="120"></el-table-column>
                            <el-table-column prop="price" label="价格" width="120"></el-table-column>
                        </el-table>
                        <!--分页-->
                        <el-pagination
                            class="pagination"
                            @size-change="handleGiftSizeChange"
                            @current-change="handleGiftCurrentChange"
                            :page-sizes="[25, 50, 75, 100]"
                            layout="total, sizes, next"
                            :background="true"
                            next-text="点击加载更多⇣⇣"
                            :total="giftTotalCount"
                        ></el-pagination>
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="showGiveaway = false">取 消</el-button>
                        <el-button type="primary" @click="getGiveawayNum">确 定</el-button>
                    </div>
                </el-dialog>
            </div>
            <!-- 促销满减列表 -->
            <div class="dataTable" v-loading="loading">
                <el-table
                    ref="singleTable"
                    :data="subtractionList"
                    style="width: 100%"
                    @selection-change="handleSelectionChange"
                    :default-sort="{prop: 'date', order: 'descending'}"
                >
                    <el-table-column property="name" prop="activeName" label="促销名称"></el-table-column>
                    <el-table-column property="dateStart" prop="startTime" label="开始时间"></el-table-column>
                    <el-table-column property="dateEnd" prop="endTime" label="结束时间"></el-table-column>
                    <el-table-column property="state" prop="status" label="状态"></el-table-column>
                    <el-table-column align="center" prop="address" label="操作">
                        <template slot-scope="scope">
                            <el-button
                                type="text"
                                size="small"
                                @click="editFullReduction(scope.row)"
                            >编辑</el-button>
                            <el-button type="text" size="small" @click="prohibitSales(scope.row)" :disabled="scope.row.status == '已过期'">使失效</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <!--分页-->
        <div class="pagination-wrapper">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync='currentPage'
                :page-sizes="[25, 50, 75, 100]"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalCount"
                center
            ></el-pagination>
        </div>
    </div>
</template>

<script>
import headerNotice from "./../../components/common/headerNotice.vue";
const cityOptions = ["上海", "北京", "广州", "深圳"];
export default {
    components: {
        headerNotice
    },
    props: {},
    data() {
        return {
            state: true,
            readonly: false, // 编辑时部分数据设置只读
            index: 0,
            dialogLoading: true,
            loading: true,
            totalCount: 0,
            currentPage: 1,
            giftTotalCount: 0,
            goodsTotalCount: 0,
            input: "",
            maxResultCount: 25, //默认一页显示的个数,
            subtractionList: [], //促销满赠列表列表主数据
            promotionName: "", //满赠名称
            stateValue: "", //满赠状态
            stateVal: 0, //满赠状态值
            dateValue: "", //满赠时间
            formData: {
                activeName: "",
                reach: 0,
                freebieNum: 0,
                startTime: "",
                endTime: "",
                customerScope: 1,
                cityScope: 1,
                itemPropScope: 1,
                content: "",
                itemPropIds: [],
                cityCodes: [],
                freebiePropIds: []
            },
            reginData: [], //区域数据
            defaultProps: {
                children: "children",
                label: "name"
            },
            checkedReginData: [], //屏蔽区域已选数据
            defaultKeys: [],
            areaNumber: 0, // 选中地区数量
            goodsNum: 0, // 选中商品数量
            giveawayNum: 0, // 选中赠品数量
            goodsList: [], // 商品列表
            giveawayList: [], // 赠品列表
            choosedItem: [], //已选择的商品列表
            goodsForm: {},
            giveawayForm: {},
            showAddBox: false, //是否展示添加弹出框
            showArea: false, // 是否展示地区列表弹出框
            showGoods: false, // 是否展示商品列表弹出框
            showGiveaway: false, // 是否展示赠品列表弹出框
            sendID: 0, // 点击详情时获取index
            itemPropIds: [], // 点击详情时获取选中商品
            freebiePropIds: [], // 点击详情时获取选中赠品
            chooseCustomerData: [], //所有选中的商品数据
            currentPageCustomer: [],//所有页选中的商品数据
            nowCurrentPageCustomer: [],//当前页选中的商品数据
            currentPageGift: [], //所有页选中的赠品数据
            nowCurrentPageGift: [], //当前页选中的赠品数据
            customerTotalCount: 0,
            options: [
                {
                    value: "0",
                    label: "全部"
                },
                {
                    value: "1",
                    label: "未开始"
                },
                {
                    value: "2",
                    label: "促销中"
                },
                {
                    value: "3",
                    label: "已过期"
                }
            ],
            pickerOptions2: {
                shortcuts: [
                    {
                        text: "最近一周",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(
                                start.getTime() - 3600 * 1000 * 24 * 7
                            );
                            picker.$emit("pick", [start, end]);
                        }
                    },
                    {
                        text: "最近一个月",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(
                                start.getTime() - 3600 * 1000 * 24 * 30
                            );
                            picker.$emit("pick", [start, end]);
                        }
                    },
                    {
                        text: "最近三个月",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(
                                start.getTime() - 3600 * 1000 * 24 * 90
                            );
                            picker.$emit("pick", [start, end]);
                        }
                    }
                ]
            },
            checkAll: false,
            cities: cityOptions,
            multipleSelection: []
        };
    },
    watch: {},
    computed: {},
    mounted() {
        this.getDatas({
            MaxResultCount: this.maxResultCount,
            Status: 0
        });
        this.getAllRegin();
        this.getGoods({
            MaxResultCount: this.maxResultCount
        });
        this.getGiveaway({
            MaxResultCount: this.maxResultCount
        })
    },
    methods: {
        //获取列表数据
        getDatas(params) {
            let self = this;
            self.loading = true;
            $http.GET({
                url:
                    this.$store.state.apiUrl +
                    "/api/services/app/AdminSendfull/GetList",
                params: params,
                success(res) {
                    for (var i = 0; i < res.items.length; i++) {
                        if (res.items[i].status == 1) {
                            res.items[i].status = "未开始";
                        } else if (res.items[i].status == 2) {
                            res.items[i].status = "促销中";
                        } else {
                            res.items[i].status = "已过期";
                        }
                    }
                    self.subtractionList = res.items;
                    self.totalCount = res.totalCount;
                    self.loading = false;
                },
                fail(res) {
                    self.loading = false;
                }
            });
        },
        // 下拉框value值获取
        selectGet(vId) {
            this.stateVal = vId;
        },
        //名称 状态 日期条件查询
        searchConfirm() {
            if(this.dateValue) {
                this.getDatas({
                    MaxResultCount: this.maxResultCount,
                    Title: this.promotionName, //商品名称
                    Status: this.stateVal, //商品状态
                    StartTime: this.dateValue[0], //商品开始时间
                    EndTime: this.dateValue[1] //商品结束时间
                });
            }else{
                this.getDatas({
                    MaxResultCount: this.maxResultCount,
                    Title: this.promotionName, //商品名称
                    Status: this.stateVal, //商品状态
                    StartTime: null, //商品开始时间
                    EndTime: null //商品结束时间
                });
            }
            this.currentPage = 1
        },
        // 弹出添加框、解除部分数据只读、清除地区选中数据和数量、清除选中商品数据和数量
        addFullFift() {
            let self = this;
            this.$router.push({
                'path':'/addFullFift'
            })
            return
            if(self.$refs.reginTree){
                self.$refs.reginTree.setCheckedKeys([]);
            }
            if(self.$refs.multipleTable){
                self.$refs.multipleTable.clearSelection();
            }
            if(self.$refs.multipleTablezp){
                self.$refs.multipleTablezp.clearSelection();
            }
            self.goodsForm.keyword = '';
            self.goodsNum = 0;
            self.giveawayNum = 0;
            self.areaNumber = 0;
            self.showAddBox = true;
            self.readonly = false;
            // 重新初始化商品列表
            this.getGoods({
                MaxResultCount: this.maxResultCount
            }, true);
            // 重新初始化商品列表
            this.getGiveaway({
                MaxResultCount: this.maxResultCount
            }, true);
        },
        //添加或编辑满赠
        addFullReduction(state) {
            let self = this;
            if(self.$refs.reginTree){
                self.$refs.reginTree.setCheckedKeys([]);
            }
            self.readonly = false;
            self.btnLoading = true;
            if (self.state == true) { // 为true时添加
                if (
                    !self.formData.activeName ||
                    !self.formData.reach ||
                    !self.formData.freebieNum ||
                    !self.formData.startTime ||
                    !self.formData.endTime
                ) {
                    self.$message.error("请检查必填项是否填写！");
                    self.btnLoading = false;
                    return;
                }
                $http.POST({
                    url:
                        this.$store.state.apiUrl +
                        "/api/services/app/AdminSendfull/Create",
                    data: self.formData,
                    success(res) {
                        self.$message({
                            message: "添加成功",
                            type: "success"
                        });
                        let params = {
                            MaxResultCount: self.maxResultCount
                        };
                        self.getDatas(params);
                        self.currentPage = 1
                        self.btnLoading = false;
                        self.showAddBox = false;
                    },
                    fail(res) {
                        self.btnLoading = false;
                    }
                });
            } else { // 为false时编辑
                if (!self.formData.activeName) {
                    self.$message.error("请检查必填项是否填写！");
                    self.btnLoading = false;
                    return;
                }
                let updateData = {
                    sendID: self.sendID,
                    activeName: self.formData.activeName,
                    content: self.formData.content,
                    customerScope: self.formData.customerScope,
                    cityScope: self.formData.cityScope,
                    itemPropScope: self.formData.itemPropScope,
                    itemPropIds: self.formData.itemPropIds,
                    cityCodes: self.formData.cityCodes,
                    freebiePropIds: self.formData.freebiePropIds
                };
                $http.PUT({
                    url:
                        this.$store.state.apiUrl +
                        "/api/services/app/AdminSendfull/Update",
                    data: updateData,
                    success(res) {
                        self.$message({
                            message: "修改成功",
                            type: "success"
                        });
                        let params = {
                            MaxResultCount: self.maxResultCount
                        };
                        self.getDatas(params);
                        self.currentPage = 1
                        self.btnLoading = false;
                        self.showAddBox = false;
                        self.state = true; // 保存编辑完毕修改确认按钮参数
                    },
                    fail(res) {
                        self.btnLoading = false;
                        self.state = true;
                    }
                });
            }
        },
        // 获取满赠详细
        editFullReduction(row) {
            let self = this;
            this.$router.push({
                'path':'/editFullFift',
                "query":{
                    'sendID':row.sendID
                }
            })
            return
            if(self.$refs.reginTree){
                self.$refs.reginTree.setCheckedKeys([]);
            }
            self.state = false; // 如果是编辑则确认按钮更改为保存编辑
            self.sendID = row.sendID; // 获取促销列表id
            self.showAddBox = true;
            self.readonly = true; // 编辑时设置部分数据只读
            $http.GET({
                url:
                    this.$store.state.apiUrl +
                    "/api/services/app/AdminSendfull/GetDetail",
                params: {
                    sendID: row.sendID
                },
                success(res) {
                    self.formData = {
                        // 获取满赠数据
                        activeName: res.activeName,
                        reach: res.reach,
                        freebieNum: res.freebieNum,
                        startTime: res.startTime,
                        endTime: res.endTime,
                        customerScope: res.customerScope,
                        cityScope: res.cityScope,
                        itemPropScope: res.itemPropScope,
                        content: res.content,
                        itemPropIds: res.itemPropIDs,
                        cityCodes: res.cityCodes,
                        freebiePropIds: res.freebiePropIds
                    };
                    self.itemPropIds = res.itemPropIDs; // 获取选中商品
                    self.goodsNum = res.itemPropIDs.length; // 获取选中商品数量
                    self.freebiePropIds = res.freebiePropIds; // 获取选中赠品
                    self.giveawayNum = res.freebiePropIds.length; // 获取选中赠品数量
                    self.defaultKeys = res.cityCodes; // 获取选中地区
                    self.areaNumber = res.cityCodes.length; // 获取选中地区数量
                    if(Number(self.goodsNum) > 25){
                        let params = {
                            MaxResultCount: self.goodsNum,
                            sendID: self.sendID
                        };
                        self.getSelectedData(params, true);
                    }else{
                        let params = {
                            MaxResultCount: 25,
                            sendID: self.sendID
                        };
                        self.getSelectedData(params, true);
                    }
                    if(Number(self.giveawayNum) > 25){
                        let params = {
                            MaxResultCount: self.giveawayNum,
                            sendID: self.sendID
                        };
                        self.getGiveawayData(params, true);
                    }else{
                        let params = {
                            MaxResultCount: 25,
                            sendID: self.sendID
                        };
                        self.getGiveawayData(params, true);
                    }
                },
                fail(res) {
                    self.dialogLoading = false;
                }
            });
        },
        // 添加或编辑弹出框关闭时清除数据
        closeDialog() {
            let self = this;
            self.formData = {
                reach: 0,
                startTime: "",
                endTime: "",
                customerScope: 1,
                cityScope: 1,
                itemPropScope: 1,
                content: "",
                itemIds: [],
                cityCodes: [],
                activeName: "",
                freebieNum: 0,
                itemPropIds: [],
                freebiePropIds: []
            };
            self.currentPageGift = [];
            self.currentPageCustomer = [];
            if(self.$refs.multipleTable){
                self.$refs.multipleTable.clearSelection();
            }
            if(self.$refs.multipleTablezp){
                self.$refs.multipleTablezp.clearSelection();
            }
        },
        //开启选择地区dialog框 获取所有省市区数据
        getAllRegin() {
            let self = this;
            self.dialogLoading = true;
            $http.GET({
                url:
                    this.$store.state.apiUrl +
                    "/api/services/app/AdminSendfull/GetProvinceList",
                success(res) {
                    self.reginData = res;
                    self.dialogLoading = false;
                },
                fail(res) {
                    self.dialogLoading = false;
                }
            });
        },
        //获取已选中的省市区数据
        getArea() {
            let self = this;
            self.showArea = false;
            let val = self.$refs.reginTree.getCheckedKeys(true, false).length;
            self.areaNumber = val;
            let arr = self.$refs.reginTree
                .getCheckedKeys(true, false)
                .map(item => Number.parseInt(item));
            self.formData.cityCodes = arr;
        },
        //获取编辑时已选中商品
        getSelectedData(params, isSearch) {
            let self = this;
            self.dialogLoading = true;
            $http.GET({
                url:
                    this.$store.state.apiUrl +
                    "/api/services/app/AdminSendfull/GetItemPropList",
                params: params,
                success(res) {
                    if (isSearch) {
                        self.goodsList = res.items;
                    } else {
                        self.goodsList = self.goodsList.concat(res.items);
                    }
                    //自动勾选接口返回已选中的客户
                    let timer = setTimeout(() => {
                        self.goodsList.forEach((ele, index) => {
                            if (ele.checked) {
                                if (self.$refs.multipleTable) {
                                    self.$refs.multipleTable.toggleRowSelection(
                                        ele,
                                        true
                                    );
                                }
                                clearTimeout(timer);
                                timer = null;
                            }
                        });
                    }, 100);
                    timer = setTimeout(() => {
                        self.goodsList.forEach((ele1, index1) => {
                            self.currentPageCustomer.forEach((ele2, index2) => {
                                if (ele1.itemID == ele2.itemID) {
                                    self.$refs.multipleTable.toggleRowSelection(
                                        ele1,
                                        true
                                    );
                                    clearTimeout(timer);
                                    timer = null;
                                }
                            });
                        });
                    }, 10);
                    self.goodsTotalCount = res.totalCount;
                    self.dialogLoading = false;
                },
                fail(res) {
                    self.dialogLoading = false;
                }
            });
        },
        openShowGoods() {
            let self = this;
            this.showGoods = true;
            let timer = setTimeout(() => {
                self.goodsList.forEach((ele, index) => {
                    if (ele.checked) {
                        if (self.$refs.multipleTable) {
                            self.$refs.multipleTable.toggleRowSelection(
                                ele,
                                true
                            );
                        }
                        clearTimeout(timer);
                        timer = null;
                    }
                });
            }, 100);
            timer = setTimeout(() => {
                self.goodsList.forEach((ele1, index1) => {
                    self.currentPageCustomer.forEach((ele2, index2) => {
                        if (ele1.itemID == ele2.itemID) {
                            self.$refs.multipleTable.toggleRowSelection(
                                ele1,
                                true
                            );
                            clearTimeout(timer);
                            timer = null;
                        }
                    });
                });
            }, 50);
        },
        //获取编辑时已选中赠品
        getGiveawayData(params, isSearch) {
            let self = this;
            self.dialogLoading = true;
            $http.GET({
                url:
                    this.$store.state.apiUrl +
                    "/api/services/app/AdminSendfull/GetFreebiePropList",
                params: params,
                success(res) {
                    if (isSearch) {
                        self.giveawayList = res.items;
                    } else {
                        self.giveawayList = self.giveawayList.concat(res.items);
                    }
                    //自动勾选接口返回已选中的客户
                    let timer = setTimeout(() => {
                        self.giveawayList.forEach((ele, index) => {
                            if (ele.checked) {
                                if (self.$refs.multipleTablezp) {
                                    self.$refs.multipleTablezp.toggleRowSelection(
                                        ele,
                                        true
                                    );
                                }
                                clearTimeout(timer);
                                timer = null;
                            }
                        });
                    }, 50);
                    timer = setTimeout(() => {
                        self.giveawayList.forEach((ele1, index1) => {
                            self.currentPageGift.forEach((ele2, index2) => {
                                if (ele1.itemID == ele2.itemID) {
                                    self.$refs.multipleTablezp.toggleRowSelection(
                                        ele1,
                                        true
                                    );
                                    clearTimeout(timer);
                                    timer = null;
                                }
                            });
                        });
                    }, 50);
                    self.giftTotalCount = res.totalCount;
                    self.dialogLoading = false;
                },
                fail(res) {
                    self.dialogLoading = false;
                }
            });
        },
        openShowGiveaway() {
            let self = this;
            this.showGiveaway = true;
            let timer = setTimeout(() => {
                self.giveawayList.forEach((ele, index) => {
                    if (ele.checked) {
                        if (self.$refs.multipleTablezp) {
                            self.$refs.multipleTablezp.toggleRowSelection(
                                ele,
                                true
                            );
                        }
                        clearTimeout(timer);
                        timer = null;
                    }
                });
            }, 50);
            timer = setTimeout(() => {
                self.giveawayList.forEach((ele1, index1) => {
                    self.currentPageGift.forEach((ele2, index2) => {
                        if (ele1.itemID == ele2.itemID) {
                            self.$refs.multipleTablezp.toggleRowSelection(
                                ele1,
                                true
                            );
                            clearTimeout(timer);
                            timer = null;
                        }
                    });
                });
            }, 50);
        },
        //获取商品列表数据
        getGoods(params, isSearch) {
            let self = this;
            self.dialogLoading = true;
            $http.GET({
                url:
                    this.$store.state.apiUrl +
                    "/api/services/app/AdminSendfull/GetItemPropList",
                params: params,
                success(res) {
                    if (isSearch) {
                        self.goodsList = res.items;
                    } else {
                        self.goodsList = self.goodsList.concat(res.items);
                    }
                    self.goodsList.forEach((ele1, index1) => {
                        self.currentPageCustomer.forEach((ele2, index2) => {
                            if(ele1.itemID == ele2.itemID){
                                setTimeout(() => {
                                    self.$refs.multipleTable.toggleRowSelection(
                                        ele1,
                                        true
                                    );
                                }, 10);
                            }
                        })
                    })
                    self.goodsTotalCount = res.totalCount;
                    self.dialogLoading = false;
                },
                fail(res) {
                    self.dialogLoading = false;
                }
            });
        },
        // 根据名称/编号/规格/规格编号  查询商品
        searchGoods() {
            let self = this;
            let Word = self.goodsForm.keyword;
            if(status){
                let params = {
                    Word: Word,
                    MaxResultCount: self.maxResultCount
                };
                self.dialogLoading = true;
                $http.GET({
                    url:
                        this.$store.state.apiUrl +
                        "/api/services/app/AdminSendfull/GetItemPropList",
                    params: params,
                    success(res) {
                        self.goodsList = res.items;
                        self.goodsTotalCount = res.totalCount;
                        self.dialogLoading = false;
                    },
                    fail(res) {
                        self.dialogLoading = false;
                    }
                });
            }else{
                let params = {
                    Word: Word,
                    sendID: self.sendID,
                    MaxResultCount: self.maxResultCount
                };
                self.getSelectedData(params, true);
            }
        },
        // 获取选中商品数量
        getGoodsNum() {
            let self = this;
            self.showGoods = false;
            let itemIDArr = [];
            self.nowCurrentPageCustomer.forEach((ele, index) => {
                itemIDArr.push(ele.itemID + "");
            });
            self.goodsNum = itemIDArr.length;
            self.formData.itemPropIds = itemIDArr;
        },
        //获取赠品列表数据
        getGiveaway(params, isSearch) {
            let self = this;
            self.dialogLoading = true;
            $http.GET({
                url:
                    this.$store.state.apiUrl +
                    "/api/services/app/AdminSendfull/GetFreebiePropList",
                params: params,
                success(res) {
                    if (isSearch) {
                        self.giveawayList = res.items;
                    } else {
                        self.giveawayList = self.giveawayList.concat(res.items);
                    }
                    self.giveawayList.forEach((ele1, index1) => {
                        self.currentPageGift.forEach((ele2, index2) => {
                            if(ele1.itemID == ele2.itemID){
                                setTimeout(() => {
                                    self.$refs.multipleTablezp.toggleRowSelection(
                                        ele1,
                                        true
                                    );
                                }, 10);
                            }
                        })
                    })
                    self.giftTotalCount = res.totalCount;
                    self.dialogLoading = false;
                },
                fail(res) {
                    self.dialogLoading = false;
                }
            });
        },
        // 根据名称/编号/规格/规格编号  查询赠品
        searchGiveaway() {
            let self = this;
            let Word = self.giveawayForm.keyword;
            if(status){
                let params = {
                    Word: Word,
                    MaxResultCount: self.maxResultCount
                };
                self.dialogLoading = true;
                $http.GET({
                    url:
                        this.$store.state.apiUrl +
                        "/api/services/app/AdminSendfull/GetFreebiePropList",
                    params: params,
                    success(res) {
                        self.giveawayList = res.items;
                        self.giftTotalCount = res.totalCount;
                        self.dialogLoading = false;
                    },
                    fail(res) {
                        self.dialogLoading = false;
                    }
                });
            }else{
                let params = {
                    Word: Word,
                    sendID: self.sendID,
                    MaxResultCount: self.maxResultCount
                };
                self.getGiveawayData(params, true);
            }
        },
        // 获取选中赠品数量
        getGiveawayNum() {
            let self = this;
            self.showGiveaway = false;
            let itemIDArr = [];
            self.nowCurrentPageGift.forEach((ele, index) => {
                itemIDArr.push(ele.propID + "");
            });
            self.giveawayNum = itemIDArr.length;
            self.formData.freebiePropIds = itemIDArr;
        },
        //  禁用满赠促销
        prohibitSales(row){
            let self = this;
            self.dialogLoading = true;
            let params = {
                sendID: row.sendID
            };
            $http.POST({
                url:
                    this.$store.state.apiUrl +
                    "/api/services/app/AdminSendfull/Cancel",
                params: params,
                success(res) {
                    self.$message({
                        message: "促销已失效",
                        type: "success"
                    });
                },
                fail(res) {
                    self.dialogLoading = false;
                }
            });
        },
        handleSelectionChange(val) {
            this.choosedItem = val;
        },
        //赠品选择Dialog框勾选
        handleGiftSelectionChange(val) {
            if(val.length > this.currentPageGift.length){
                this.currentPageGift = val;
            }
            this.nowCurrentPageGift = val;
        },
        //商品选择Dialog框勾选
        handleCustomerSelectionChange(val) {
            if(val.length > this.currentPageCustomer.length){
                this.currentPageCustomer = val;
            }
            this.nowCurrentPageCustomer = val;
        },
        // 商品选择Dialog框勾选一页显示多少个
        handleCustomeSizeChange(val) {
            let self = this;
            this.chooseCustomerData = this.chooseCustomerData.concat(
                this.currentPageCustomer
            );
            this.maxResultCount = val;
            let Word = self.goodsForm.keyword;
            let params = {};
            if(self.state){
                params = {
                    Word: Word,
                    MaxResultCount: val
                };
                self.getGoods(params, true);
            }else{
                params = {
                    Word: Word,
                    sendID: self.sendID,
                    MaxResultCount: val
                };
                self.getSelectedData(params, true);
            }
        },
        // 商品选择Dialog框跳转到指定页
        handleCustomerCurrentChange(val) {
            let self = this;
            this.chooseCustomerData = this.chooseCustomerData.concat(
                this.currentPageCustomer
            );
            let skipCount = (val - 1) * this.maxResultCount;
            let params = {};
            if(self.state){
                params = {
                    SkipCount: skipCount,
                    MaxResultCount: self.maxResultCount,
                    Word: self.goodsForm.keyword
                };
                self.getGoods(params, false);
            }else{
                params = {
                    Word: self.goodsForm.keyword,
                    sendID: self.sendID,
                    SkipCount: skipCount,
                    MaxResultCount: self.maxResultCount
                };
                self.getSelectedData(params, false);
            }
        },
        // 赠品选择Dialog框勾选一页显示多少个
        handleGiftSizeChange(val) {
            let self = this;
            this.chooseCustomerData = this.chooseCustomerData.concat(
                this.currentPageGift
            );
            this.maxResultCount = val;
            let Word = self.giveawayForm.keyword;
            let params = {};
            if(self.state){
                params = {
                    Word: Word,
                    MaxResultCount: val
                };
                self.getGiveaway(params, true);
            }else{
                params = {
                    Word: Word,
                    sendID: self.sendID,
                    MaxResultCount: val
                };
                self.getGiveawayData(params, true);
            }
        },
        // 赠品选择Dialog框跳转到指定页
        handleGiftCurrentChange(val) {
            let self = this;
            this.chooseCustomerData = this.chooseCustomerData.concat(
                this.currentPageGift
            );
            let skipCount = (val - 1) * this.maxResultCount;
            let params = {};
            if(self.state){
                params = {
                    SkipCount: skipCount,
                    MaxResultCount: self.maxResultCount,
                    Word: self.goodsForm.keyword
                };
                self.getGiveaway(params, false);
            }else{
                params = {
                    Word: self.goodsForm.keyword,
                    sendID: self.sendID,
                    SkipCount: skipCount,
                    MaxResultCount: self.maxResultCount
                };
                self.getGiveawayData(params, false);
            }
        },
        //一页显示多少个
        handleSizeChange(val) {
            this.maxResultCount = val;
            let params = {
                MaxResultCount: val
            };
            this.getDatas(params);
        },
        //跳转到指定页
        handleCurrentChange(val) {
            this.loading = true;
            let skipCount = (val - 1) * this.maxResultCount;
            let params = {
                SkipCount: skipCount,
                MaxResultCount: this.maxResultCount
            };
            this.getDatas(params);
        }
    },
};
</script>
<style lang="scss" scoped>
.depot {
    // 搜索
    .seach-box {
        border: 1px solid rgba(228, 228, 228, 1);
        margin: 20px 50px;
        .title {
            display: flex;
            align-items: center;
            height: 50px;
            font-weight: 400;
            background-color: rgba(243, 243, 243, 1);
            border-bottom: 1px solid rgba(228, 228, 228, 1);
            padding-left: 20px;
            // i:first-child {
            //   width: 18px;
            //   height: 18px;
            //   background: green;
            // }
        }
        .input-wrapper {
            display: flex;
            align-items: center;
            height: 60px;
            padding-left: 40px;
            .el-search {
                width: 180px;
            }
            .status {
                margin-left: 40px;
            }
        }
    }

    // 仓库列表
    .depot-list {
        margin: 0 50px;
        border: 1px solid rgba(228, 228, 228, 1);
        font-weight: 400;
        .head {
            display: flex;
            align-items: center;
            justify-content: space-between;
            background-color: rgba(243, 243, 243, 1);
            border-bottom: 1px solid rgba(228, 228, 228, 1);
            .title {
                display: flex;
                align-items: center;
                height: 50px;
                font-weight: 400;
                padding-left: 20px;
                // i:first-child {
                //   width: 18px;
                //   height: 18px;
                //   background: green;
                // }
            }
        }
        .control {
            .tip-box {
                width: 80px;
                padding-left: 0;
                padding-right: 0;
                margin-right: 20px;
            }
            .select-box {
                width: 100px;
                margin-left: 20px;
            }
        }
        // 弹出框
        .add-box {
            // width: 600px;
            /deep/ .el-dialog__header {
                display: flex;
                align-items: center;
                padding-top: 14px;
                background: rgba(242, 242, 242, 1);
                font-weight: 700;
            }
            .from-el {
                width: 600px;
            }
            .input-el {
                width: 420px;
            }
        }
    }
    // 分页
    .pagination-wrapper {
        text-align: center;
        margin-top: 20px;
    }
    // 文本框
    .el-textarea {
        width: 80%;
    }
}
</style>